import { NgModule } from "@angular/core";
import { BHQrCodeSiteScannerFormComponent } from './bh-qrcode-site-scanner-form/bh-qrcode-site-scanner-form.component';
import { DynamicBHQrCodeSiteScannerComponent } from './dynamic-bh-qrcode-site-scanner.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { BHQrCodeSiteScannerDesignComponent } from './bh-qrcode-site-scanner-design/bh-qrcode-site-scanner-design.component';
import { BHQrCodeSiteScannerResultComponent } from './bh-qrcode-site-scanner-result/bh-qrcode-site-scanner-result.component';
import { BHQrCodeSiteScannerService } from './bh-qrcode-site-scanner.service';
import { KendoModule } from '../../kendo.module';
import { MaterialModule } from 'src/app/shared/material.module';
import { MdBhQrCodeSiteScannerMotifDialog } from "./bh-qrcode-site-scanner-form/@modals/md-bh-qrcode-site-scanner-motif-dialog/md-bh-qrcode-site-scanner-motif-dialog.component";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ScrollingModule } from "@angular/cdk/scrolling";

@NgModule({
    declarations: [
        BHQrCodeSiteScannerResultComponent,
        BHQrCodeSiteScannerDesignComponent,
        BHQrCodeSiteScannerFormComponent, DynamicBHQrCodeSiteScannerComponent,
        MdBhQrCodeSiteScannerMotifDialog
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        KendoModule,
        MaterialModule,
        NgxMatSelectSearchModule,
        ScrollingModule
    ],
    providers: [
        BHQrCodeSiteScannerService
    ],
    exports: [
        BHQrCodeSiteScannerFormComponent
    ],
    entryComponents: [
        DynamicBHQrCodeSiteScannerComponent,
        MdBhQrCodeSiteScannerMotifDialog
    ]
})
export class BHQrCodeSiteScannerModule {}